import React from 'react';

// The small up-right arrow used on links
export default function Arrow() {
  return <svg className="arrow" viewBox="0 0 12 12" aria-hidden="true"><path d="M3 9 9 3M4 3h5v5" fill="none" stroke="currentColor" strokeWidth="1.3" /></svg>;
}

export function BackArrow() {
  return (
    <svg className="arrow" viewBox="0 0 12 12" aria-hidden="true">
      <path d="M10 6H2M5.5 2.5 2 6l3.5 3.5" fill="none" stroke="currentColor" strokeWidth="1.3" />
    </svg>
  );
}
